import React from 'react';
import InvoiceItem from './InvoiceItem';
import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import './InvoiceForm.css'; // Import the CSS file
import InvoiceHeader from './InvoiceHeader';
// import Card from 'react-bootstrap/Card';
import InvoiceModal from './InvoiceModal';

class InvoiceForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            currency: '₹',
            currentDate: '',
            billFromWhom: '',
            invoiceNumber: '',
            dateOfIssue: '',
            billTo: '',
            billToEmail: '',
            billToAddress: '',
            billFrom: '',
            billFromEmail: '',
            billFromAddress: '',
            notes: '',
            total: '0.00',
            subTotal: '0.00',
            subAmount: '0.00',
            cgstRate: '',
            sgstRate: '',
            igstRate: '',
            cgstAmount: '0.00',
            sgstAmount: '0.00',
            igstAmount: '0.00',
            shippingRate: '',
            shippingAmmount: '0.00',
            amountPaid: '0.00',
            balanceDue: '0.00',
            logo: null,
            discountType: 'percentage', // 'percentage' or 'amount'
            discountRate: '',
            discountAmmount: '0.00',
            adjustment: '0.00'
        };
        this.state.items = [
            {
                id: 0,
                name: '',
                price: '1.00',
                cgst: '0',
                sgst: '0',
                igst: '0',
                subamount: '',
                quantity: 1
            }
        ];
        this.editField = this.editField.bind(this);
        this.handleAmountPaidChange = this.handleAmountPaidChange.bind(this); // Bind new handler
        this.handleAdjustmentChange = this.handleAdjustmentChange.bind(this);
        this.handleLogoUpload = this.handleLogoUpload.bind(this);
    }

    handleInvoiceNumberChange = (event) => {
        let inputValue = event.target.value;
        if (!inputValue.startsWith('#')) {
            inputValue = '#' + inputValue;
        }
        this.setState({ invoiceNumber: inputValue });
    };

    handleLogoUpload(logo) {
        this.setState({ logo });
    }

    handleAdjustmentChange(event) {
        const adjustmentValue = event.target.value;

        // Allow only valid numeric inputs, including empty and negative signs
        if (/^-?\d*\.?\d*$/.test(adjustmentValue)) {
            this.setState({ adjustment: adjustmentValue }, () => this.handleCalculateTotal());
        }
    }

    handleDiscountRateChange = (event) => {
        let inputValue = event.target.value;

        //Handle empty string
        if (inputValue === "") {
            this.setState({ discountRate: "" }, () => this.handleCalculateTotal());
            return;
        }

        // Remove leading zeros (if any)
        inputValue = inputValue.replace(/^0+/, '');

        // Allow only numbers and a single decimal point
        if (/^\d*\.?\d*$/.test(inputValue)) {
            this.setState({ discountRate: inputValue }, () => this.handleCalculateTotal());
        }
    };
    handleDiscountAmountChange = (event) => {
        this.setState({ discountAmount: event.target.value }, () => this.handleCalculateTotal());
    };

    handleDiscountTypeChange = (event) => {
        this.setState({ discountType: event.target.value, discountRate: '', discountAmount: '0.00' }, () => this.handleCalculateTotal()); // Reset values
    };

    componentDidMount() {
        this.handleCalculateTotal()
    }
    handleRowDel(item) {
        this.setState(prevState => ({
            items: prevState.items.filter(it => it.id !== item.id)
        }), () => {
            this.handleCalculateTotal()
            this.calculateBalanceDue();
        });
    };
    handleCalculateTotal() {
        var items = this.state.items;
        var subTotal = 0;
        let totalGstRate = 0;
        let totalGstAmount = 0;
        let cgstTotal = 0;
        let totalCgstRate = 0;
        let totalSgstRate = 0;
        let totalIgstRate = 0;
        let sgstTotal = 0;
        let igstTotal = 0;
        // var discountAmount = 0;
        
        let itemsWithAmounts = this.state.items.map(item => {
            const itemPrice = parseFloat(item.price) || 0;
            const itemQuantity = parseInt(item.quantity) || 0;
            let itemSubtotal = itemPrice * itemQuantity;

            const cgstRate = parseFloat(item.cgst) || 0;
            const sgstRate = parseFloat(item.sgst) || 0;
            const igstRate = parseFloat(item.igst) || 0;
            
            const cgstAmount = itemSubtotal * (cgstRate / 100);
            const sgstAmount = itemSubtotal * (sgstRate / 100);
            const igstAmount = itemSubtotal * (igstRate / 100);

            cgstTotal += cgstAmount;
            totalCgstRate += cgstRate;

            sgstTotal += sgstAmount;
            totalSgstRate += sgstRate;
            
            igstTotal += igstAmount;
            totalIgstRate += igstRate;

            itemSubtotal += cgstAmount + sgstAmount + igstAmount;
            let itemTotalGstRate = cgstRate + sgstRate + igstRate;
            let itemTotalGstAmount = cgstAmount + sgstAmount + igstAmount;

            subTotal += itemSubtotal;
            totalGstRate += itemTotalGstRate;
            totalGstAmount += itemTotalGstAmount;
            return { ...item, amount: itemSubtotal.toFixed(2), gstRate: itemTotalGstRate.toFixed(2), gstAmount: itemTotalGstAmount.toFixed(2) }; // Add calculated amount to item
        });
        const totalCgstPercent = (totalCgstRate / items.length).toFixed(2); // Calculate average cgst
        const totalSgstPercent = (totalSgstRate / items.length).toFixed(2); // Calculate average sgst
        const totalIgstPercent = (totalIgstRate / items.length).toFixed(2); // Calculate average igst

        let discountAmount = 0;
        let discountRate = 0;

        if (this.state.discountType === 'percentage') {
            const discountValue = parseFloat(this.state.discountRate) || 0;
            discountAmount = subTotal * (discountValue / 100); // Calculate without toFixed initially

            if (isNaN(discountAmount)) {
                discountAmount = 0;
            }
            discountAmount = discountAmount.toFixed(2);
            discountRate = discountValue;
        } else if (this.state.discountType === 'amount') {
            discountAmount = parseFloat(this.state.discountAmount) || 0;
            if (isNaN(discountAmount)) {
                discountAmount = 0;
            }
            if (subTotal > 0) {
                discountRate = (discountAmount / subTotal) * 100;
                if (isNaN(discountRate)) {
                    discountRate = 0;
                }
                discountRate = discountRate.toFixed(2);
            } else {
                discountRate = 0;
            }
            discountAmount = discountAmount.toFixed(2);
        }

        const shippingAmount = parseFloat(this.state.shippingRate) || 0;
        const adjustment = parseFloat(this.state.adjustment) || 0;

        let total = (subTotal + shippingAmount - parseFloat(discountAmount) + adjustment);
        if (isNaN(total)) {
            total = 0;
        }
        total = total.toFixed(2);

        this.setState({
            items: itemsWithAmounts, // Update items with calculated amounts
            subTotal: subTotal.toFixed(2),
            gstRate: (totalGstRate).toFixed(2), //total gst rate
            gstAmount: (totalGstAmount).toFixed(2), //total gst amount
            shippingAmmount: shippingAmount.toFixed(2),
            discountAmmount: discountAmount, // Store as string after toFixed
            discountRate: discountRate,
            cgstAmount: (cgstTotal).toFixed(2),
            cgstRate: totalCgstPercent,
            sgstAmount: (sgstTotal).toFixed(2),
            sgstRate: totalSgstPercent,
            igstAmount: (igstTotal).toFixed(2),
            igstRate: totalIgstPercent,
            total: total
        }, () => this.calculateBalanceDue());
    };
    onItemizedItemEdit(evt) {
        var item = {
            id: evt.target.id,
            name: evt.target.name,
            value: evt.target.value
        };
        var items = this.state.items.slice();
        var newItems = items.map(function (items) {
            for (var key in items) {
                if (key == item.name && items.id == item.id) {
                    items[key] = item.value;
                }
            }
            return items;
        });
        this.setState({ items: newItems });
        this.handleCalculateTotal();
        this.setState(prevState => ({
            items: prevState.items.map(it => {
                if (it.id === item.id) {
                    return { ...it, [item.name]: item.value }; // Update the changed property
                }
                return it;
            })
        }), () => this.handleCalculateTotal());
    };
    handleAddEvent() {
        var id = (+ new Date() + Math.floor(Math.random() * 999999)).toString(36);
        var newItem = {
            id: id,
            name: '',
            price: '1.00',
            cgst: '0',
            sgst: '0',
            igst: '0',
            subamount: '',
            quantity: 1,
            amount: '0.00',
            gstRate: '0.00',
            gstAmount: '0.00',
            cgstRate: '0.00',
            cgstAmount: '0.00'
        }
        this.setState(prevState => ({ items: [...prevState.items, newItem] }), () => {
            this.handleCalculateTotal()
            this.calculateBalanceDue();
        });
    }
    editField = (event) => {
        this.setState({
            [event.target.name]: event.target.value || ''
        }, () => this.handleCalculateTotal());
    };
    onCurrencyChange = (selectedOption) => {
        this.setState(selectedOption);
    };

    handleAmountPaidChange(event) {
        this.setState({ amountPaid: event.target.value }, () => this.calculateBalanceDue());
    }
    calculateBalanceDue() {
        const total = parseFloat(this.state.total) || 0;
        const amountPaid = parseFloat(this.state.amountPaid) || 0;
        const balanceDue = (total - amountPaid).toFixed(2);
        this.setState({ balanceDue });
    }
    openModal = (event) => {
        event.preventDefault();
        this.handleCalculateTotal();

        // Get the billFromWhom field from state and ensure it is a string
        // let billFromWhom = this.state.billFromWhom;

        // If it's not a string, convert it to an empty string
        // if (typeof billFromWhom !== 'string') {
        //     billFromWhom = '';
        // }

        // Split the text into lines
        // const lines = billFromWhom.split('\n');

        // Format the first line to bold and preserve remaining lines
        // const formattedBillFromWhom = (
        //     <div>
        //         {lines.length > 0 && 
        //         <span style={{ fontWeight: 'bold' }}>{lines[0]}</span>}
        //         {lines.length > 1 && <br />}
        //         {lines.slice(1).join('\n')}
        //     </div>
        // );
        // this.setState({
        //     isOpen: true,
        //     formattedBillFromWhomForModal: formattedBillFromWhom,
        // });

        const billFromWhom = String(this.state.billFromWhom || ""); // Ensure it's a string
        this.setState({
            isOpen: true,
            formattedBillFromWhomForModal: billFromWhom,
        });
    };
    closeModal = (event) => this.setState({ isOpen: false });

    render() {
        return (

            < div className='main' >
                {/* <Card className="p-4 p-xl-5 my-3 my-xl-4"> */}

                < div className='left-pane' >
                    <InvoiceHeader logo={this.state.logo} onLogoUpload={this.handleLogoUpload} invoiceNumber={this.state.invoiceNumber} onInvoiceNumberChange={this.handleInvoiceNumberChange}></InvoiceHeader>
                    <div className='invoice-form'>
                        <div className='left-form left-form1'>
                            <div className="upper-column">
                                <textarea id="who-is-this-from" rows="3" placeholder="Who is this from?" className='textarea-left-form' name="billFromWhom" value={this.state.billFromWhom} onChange={(e) => this.setState({ billFromWhom: e.target.value })} />
                            </div>
                            <div className="columns">
                                <div className="column">
                                    <h3 className='col-heading'>Bill To</h3>
                                    {/* earlier it was billed from */}
                                    <textarea id="billed-from" rows="3" className='textarea-left-form' placeholder="Your business details" name="billFrom" value={this.state.billFrom} onChange={this.editField} />
                                </div>
                                <div className="column">
                                    <h3 className='col-heading'>Ship To</h3>
                                    {/* earlier it was billed to */}
                                    <textarea id="billed-to" rows="3" className='textarea-left-form' placeholder="Customer details" name="billTo" value={this.state.billTo} onChange={this.editField} />
                                </div>
                            </div>
                        </div>
                        <div className='right-form right-form1'>
                            <div class="right-form-subpart">
                                <label for="date" className='fw-bold right-form-label'>Date:</label>
                                <input type="date" id="date" required className='textarea-right-form' name='dateOfIssue' value={this.state.dateOfIssue} onChange={this.editField} />
                            </div>
                            <div class="right-form-subpart">
                                <label for="payment term" className='fw-bold right-form-label'>Payment Term:</label>
                                <input type="text" id="payment-term" className='textarea-right-form' name='paymentTerm' value={this.state.paymentTerm} onChange={this.editField} />
                            </div>
                            <div class="right-form-subpart">
                                <label for="due date" className='fw-bold right-form-label'>Due Date:</label>
                                <input type="date" id="due-date" className='textarea-right-form' name='dueDate' value={this.state.dueDate} onChange={this.editField} />
                            </div>
                            <div class="right-form-subpart">
                                <label for="po number" className='fw-bold right-form-label'>PO Number:</label>
                                <input type="number" id="po-number" className='textarea-right-form' name='poNumber' value={this.state.poNumber} onChange={this.editField} />
                            </div>
                        </div>
                    </div >
                    
                    <InvoiceItem onItemizedItemEdit={this.onItemizedItemEdit.bind(this)} onRowAdd={this.handleAddEvent.bind(this)} onRowDel={this.handleRowDel.bind(this)} currency={this.state.currency} items={this.state.items} />
                    <hr style={{marginBottom:'1.25rem'}}></hr>
                    <div className='bottom-pane'>
                        <div className='bottom-left-pane'>
                            <div className="notes-div">
                                <h3 className='bottom-pane-col-heading'>Notes</h3>
                                <textarea id="notes" rows="2" className='text-[13px] textarea-bottom-left-pane' placeholder="Notes - any relevant information not already covered" name="notes" value={this.state.notes} onChange={this.editField} />
                            </div>
                            <div className="terms-div">
                                <h3 className='bottom-pane-col-heading'>Terms</h3>
                                <textarea id="terms" rows="2" className='text-[13px] textarea-bottom-left-pane' placeholder="Terms and conditions - late fees, payment methods, delivery schedule" name="terms" value={this.state.terms} onChange={this.editField} />
                            </div>
                        </div>
                        <div className='bottom-right-pane'>
                            <Row className="mt-4 justify-content-end">
                                <Col lg={10}>
                                    <div className="d-flex flex-row text-[13px] align-items-start justify-content-between">
                                        <span className="fw-bold">Subtotal:
                                        </span>
                                        <span>{this.state.currency}
                                            {this.state.subTotal}</span>
                                    </div>
                                    {parseFloat(this.state.discountRate) > 0 && (
                                        <div className="d-flex flex-row align-items-start justify-content-between mt-2">
                                            <span className="text-[13px] fw-bold">Discount:</span>
                                            <span>
                                                <span className="small ">({this.state.discountRate}%)</span>
                                                {this.state.currency}
                                                {this.state.discountAmmount || 0}</span>
                                        </div>
                                    )}
                                    {/* <div className="d-flex flex-row align-items-start justify-content-between mt-2">
                                        <span className="fw-bold">GST:
                                        </span>
                                        <span>
                                            <span className="small ">({this.state.gstRate || 0}%)</span>
                                            {this.state.currency}
                                            {this.state.gstAmount || 0}
                                        </span>
                                    </div> */}
                                    {/* Conditionally render shipping if CGSTAmount is greater than 0 */}
                                    {parseFloat(this.state.cgstAmount) > 0 && (
                                        <div className="d-flex flex-row align-items-start justify-content-between mt-2">
                                            <span className="fw-bold">CGST:</span>
                                            <span>
                                                <span className="small ">({this.state.cgstRate || 0}%)</span>
                                                {this.state.currency}
                                                {this.state.cgstAmount || 0}
                                            </span>
                                        </div>
                                    )}
                                    {/* Conditionally render shipping if SGSTAmount is greater than 0 */}
                                    {parseFloat(this.state.sgstAmount) > 0 && (
                                        <div className="d-flex flex-row align-items-start justify-content-between mt-2">
                                            <span className="fw-bold">SGST:</span>
                                            <span>
                                                <span className="small ">({this.state.sgstRate || 0}%)</span>
                                                {this.state.currency}
                                                {this.state.sgstAmount || 0}
                                            </span>
                                        </div>
                                    )}
                                    {/* Conditionally render shipping if IGSTAmount is greater than 0 */}
                                    {parseFloat(this.state.igstAmount) > 0 && (
                                        <div className="d-flex flex-row align-items-start justify-content-between mt-2">
                                            <span className="fw-bold">IGST:</span>
                                            <span>
                                                <span className="small ">({this.state.igstRate || 0}%)</span>
                                                {this.state.currency}
                                                {this.state.igstAmount || 0}
                                            </span>
                                        </div>
                                    )}
                                    {/* Conditionally render shipping if shippingAmount is greater than 0 */}
                                    {parseFloat(this.state.shippingAmmount) > 0 && (
                                        <div className="d-flex flex-row align-items-start justify-content-between mt-2">
                                            <span className="fw-bold">Shipping:</span>
                                            <span>{this.state.currency} {this.state.shippingAmmount}</span>
                                        </div>
                                    )}
                                    <div className="d-flex flex-row align-items-start justify-content-between mt-2">
                                        <span className="fw-bold">Adjustment
                                        </span>
                                        <span className='input-span'>
                                            <input
                                                type='number'
                                                name="adjustment"
                                                value={this.state.adjustment}
                                                onChange={this.handleAdjustmentChange}
                                                // placeholder='0.00'
                                                // min="0.00"
                                                step="0.01"
                                                className='input-width'
                                            />
                                        </span>
                                    </div>
                                    <hr />
                                    <div className="d-flex flex-row align-items-start justify-content-between">
                                        <span className="fw-bold">Total:
                                        </span>
                                        <span className="fw-bold">{this.state.currency}
                                            {this.state.total || 0}</span>
                                    </div>
                                    <div className="d-flex flex-row align-items-center justify-content-between mt-2 amount-paid-container">
                                        <span className="fw-bold">Amount Paid:
                                        </span>
                                        <span className='input-span'>
                                            <input
                                                type='number'
                                                name="amountPaid"
                                                value={this.state.amountPaid}
                                                onChange={this.handleAmountPaidChange}
                                                // placeholder='0.00'
                                                min="0.00"
                                                step="0.01"
                                                className='input-width'
                                            />
                                        </span>
                                    </div>
                                    {parseFloat(this.state.amountPaid) > 0 && (
                                        <div className="d-flex flex-row align-items-start justify-content-between mt-2">
                                            <span className="fw-bold">Balance Due:
                                            </span>
                                            <span>
                                                {this.state.currency} {this.state.balanceDue}
                                            </span>
                                        </div>
                                    )}
                                </Col>
                            </Row>
                        </div>
                    </div>
                    <div className="authorized-signature">
                        <div className="signature-space" style={{ height: '100px', borderBottom: '1px solid black', marginBottom: '5px' }}>
                            {/* Space for signature */}
                        </div>
                        <div className="signature-label" style={{ textAlign: 'center', fontSize: '13px', fontWeight: 'bold'}}>
                            Authorized Signature
                        </div>
                    </div>
                </div >
                {/* </Card> */}
                < div className='right-pane' >

                    <div className="sticky-top pt-md-3 pt-xl-4">
                        <Button variant="primary" onClick={this.openModal} className="d-block w-100">Review Invoice</Button>
                        <InvoiceModal showModal={this.state.isOpen} closeModal={this.closeModal} info={{ ...this.state, logo: this.state.logo, billFromWhom: this.state.formattedBillFromWhomForModal }} items={this.state.items} currency={this.state.currency} subTotal={this.state.subTotal} taxAmmount={this.state.taxAmmount} discountAmmount={this.state.discountAmmount} total={this.state.total} />
                        <Form.Group className="mb-3">
                            <Form.Label className="fw-bold">Currency:</Form.Label>
                            <Form.Select onChange={event => this.onCurrencyChange({ currency: event.target.value })} className="btn btn-light my-1 dropdown" aria-label="Change Currency">
                                <option value="₹">INR (Indian Rupee)</option>
                                <option value="$">USD (United States Dollar)</option>
                                <option value="£">GBP (British Pound Sterling)</option>
                                <option value="¥">JPY (Japanese Yen)</option>
                                <option value="$">CAD (Canadian Dollar)</option>
                                <option value="$">AUD (Australian Dollar)</option>
                                <option value="$">SGD (Signapore Dollar)</option>
                                <option value="¥">CNY (Chinese Renminbi)</option>
                                <option value="₿">BTC (Bitcoin)</option>
                            </Form.Select>
                        </Form.Group>
                        <Form.Group className="my-3">
                            <Form.Label className="fw-bold">Discount:</Form.Label>
                            <InputGroup className="my-1 flex-nowrap">
                                {this.state.discountType === 'percentage' ? (
                                    <Form.Control
                                        name="discountRate"
                                        type="text"
                                        value={this.state.discountRate}
                                        onChange={this.handleDiscountRateChange} // Use specific handler
                                        className="bg-white border"
                                        placeholder="0.00"
                                        min="0.00"
                                        step="0.01"
                                        style={{fontSize:'13px'}}
                                    />
                                ) : (
                                    <Form.Control
                                        name="discountAmount"
                                        type="number"
                                        value={this.state.discountAmount}
                                        onChange={this.handleDiscountAmountChange} // Use specific handler
                                        className="bg-white border"
                                        placeholder="0.00"
                                        min="0.00"
                                        step="0.01"
                                        style={{fontSize:'13px'}}
                                    />
                                )}
                                <Form.Select
                                    style={{ maxWidth: '70px' }}
                                    value={this.state.discountType}
                                    onChange={this.handleDiscountTypeChange}
                                    className="bg-white border"
                                >
                                    <option value="percentage">%</option>
                                    <option value="amount">{this.state.currency}</option>
                                </Form.Select>
                            </InputGroup>
                        </Form.Group>
                        <Form.Group className="my-3">
                            <Form.Label className="fw-bold">Shipping rate:</Form.Label>
                            <InputGroup className="my-1 flex-nowrap">
                                <Form.Control 
                                name="shippingRate" 
                                type="number" 
                                value={this.state.shippingRate} 
                                onChange={(event) => this.editField(event)} 
                                className="bg-white border" 
                                placeholder="0.0" 
                                min="0.00" 
                                step="0.01" 
                                max="100.00"
                                style={{fontSize:'13px'}} />
                            </InputGroup>
                        </Form.Group>
                    </div>

                </div >
            </div >

        );
    }
}
export default InvoiceForm;